// filtersSelectors.js
import { createSelector } from '@reduxjs/toolkit';

export const selectFilters = (state) => state.filters;

export const selectTextFilter = createSelector(selectFilters, (filters) => filters.text);
export const selectLangFilter = createSelector(selectFilters, (filters) => filters.lang);
export const selectPageFilter = createSelector(selectFilters, (filters) => filters.page);
export const selectCapacityFilter = createSelector(selectFilters, (filters) => filters.capacity);
export const selectInstantBooking = createSelector(selectFilters, (filters) => filters.instant_booking);
// Add other selectors as needed
